import { mangaList } from '@/mocks/mangaData';
import MangaCard from '@/components/base/MangaCard';

export default function PopularManga() {
  const popular = mangaList
    .filter((m) => m.rating >= 9.0)
    .sort((a, b) => b.views - a.views)
    .slice(0, 8);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
      {popular.map((manga) => (
        <MangaCard key={manga.id} {...manga} />
      ))}
    </div>
  );
}